<huge-row>
	<mat-button-toggle-group
		style="width: 100%; margin-left: 10px;"
		[(ngModel)]="segmentIndex"
		mode="ios">
		@for (device of tileData; track device; let i = $index) {
<mat-button-toggle
			style="color: white; width: 100%;"
			[value]="i">
			{{ device.title }}
		</mat-button-toggle>
}
	</mat-button-toggle-group>
</huge-row>
@for (device of tileData; track device; let i = $index) {
<huge-row>
	@if (i == segmentIndex) {
<mat-col
	
		style="margin: 10px 10px; width: 100%; display: flex;">
		<app-data-value-row-card [dataValues]="device.values" style="flex-grow: 1;"></app-data-value-row-card>
	</mat-col>
}
</huge-row>
}
